import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7cdc5e14"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "mg-b--35"
};
const _hoisted_3 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_4 = ["width"];
const _hoisted_5 = {
  class: "slot__series"
};
import FormGroup from '../components/FormGroup/index.vue';
import FormItem from '../components/FormItem/index.vue';
import SearchDialog from '../components/SearchDialog/index.vue';
import { ref, inject, onMounted } from 'vue';
import { isEmptyArray } from '@/utils';
import { useI18n } from 'vue-i18n';
import { getItemByProp, getArrByReduce, debounce } from '@/utils/tools';
import { paymentFormList } from '@/assets/config/dicts';
import { useCountryList } from '@/utils/cacheData';
import { useCommon } from '@/store/useCommon';
import { validatorNonNull } from '@/utils/validate';
import { getProgramSetApi, getCloudDiskOptionsApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['toSeriesFilm'],

  setup(__props, {
    expose,
    emit
  }) {
    const {
      t
    } = useI18n();
    const TopFormRef = ref();
    const FormRef = ref();
    const searchDialogRef = ref();
    const cloudDiskOptions = ref();
    const finishData = inject('finishData');
    const languageOptions = inject('languageOptions');
    const mediaParams = inject('mediaParams');
    const topformConfig = reactive({
      formList: [[{
        label: '名称',
        prop: 'name',
        widgetType: 'input',
        required: true,
        placeholder: '请输入名称',
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 255,
          message: t('限制字符数量', {
            num: 255
          }),
          trigger: 'blur'
        }]
      }, {
        label: '影片类型',
        prop: 'programType',
        widgetType: 'Select',
        required: true,
        disabled: false,
        list: [{
          label: t('单片'),
          value: 'movie'
        }, {
          label: t('剧集'),
          value: 'tv_series'
        }],
        change: val => {
          let item = getItemByProp(formConfig.formList, 'genreList');
          item.programType = val;
        },
        controller: (value, data, config) => {
          config.disabled = finishData.value.id || mediaParams.value ? true : false;
          return true;
        }
      }], [{
        label: '成人内容',
        prop: 'adult',
        widgetType: 'Select',
        required: true,
        list: [{
          label: t('是'),
          value: 'yes'
        }, {
          label: t('否'),
          value: 'no'
        }]
      }, {
        label: '关联系列',
        prop: 'videoSeriesIdList',
        itemSlot: true,
        widgetType: 'multipleSelect',
        list: [],
        onPopoverShow: debounce(() => {
          getProgramSet();
        }, 200)
      }], [{
        label: '关联网盘',
        prop: 'cloudDiskIdList',
        widgetType: 'multipleSelect',
        list: cloudDiskOptions,
        valueField: 'id',
        nameField: 'username'
      }, {
        label: '付费设置',
        prop: 'paymentForm',
        widgetType: 'Select',
        list: paymentFormList
      } // {
      //   label: '季', prop: 'sequence', widgetType: 'input', required: true,
      //   controller: (value, data, config) => {
      //     return topformConfig.formData.programType == 'tv_series';
      //   },
      //   rules: [
      //     { required: true, validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入季'), trigger: ['change', 'blur'] },
      //     {
      //       validator: (rule, value, callback) => {
      //         if (!/^[1-9]\d*$/.test(String(value))) {
      //           callback(new Error(t('请输入大于0的整数')))
      //         } else if (String(value).length > 3) {
      //           callback(new Error(t('限制字符数量', { num: 3 })))
      //         } else if (value !== 0 && String(value).length <= 3) {
      //           callback();
      //         }
      //       }, trigger: ['change', 'blur']
      //     }
      //   ],
      //   onInput: (val) => {
      //     topformConfig.formData.sequence = topformConfig.formData.sequence.replace(/[^\d]/g, '');
      //   }
      // },
      ]],
      formData: {
        name: finishData.value.name || '',
        programType: finishData.value.programType,
        adult: finishData.value.adult || 'no',
        videoSeriesIdList: finishData.value.videoSeriesIdList || [],
        sequence: finishData.value.sequence || '',
        cloudDiskIdList: finishData.value.cloudDiskIdList || [],
        paymentForm: 3
      }
    });
    const selectOptions = computed(() => {
      const options = [];
      languageOptions.value.forEach(item => {
        options.push({ ...item,
          disabled: false
        });
      });
      return options;
    });
    const options = reactive({
      dialogOptions: {},
      languageOptions: selectOptions
    }); // 已选的语言加上禁用

    const addDisabledForOptions = val => {
      if (!isEmptyArray(val)) {
        let ids = getArrByReduce(val, 'language');
        selectOptions.value.forEach(item => {
          item.disabled = ids.includes(item['label']) ? true : false;
        });
      }
    };

    const getProxyObj = defaultLanguage => {
      return new Proxy({
        language: defaultLanguage || '',
        infoId: 'tmdb',
        imdbId: '',
        name: '',
        year: '',
        length: '',
        country: '',
        genreList: [],
        releaseDate: '',
        videoId: '',
        rating: '',
        certification: '',
        directorList: [],
        actorList: [],
        description: '',
        //ifChange: false,
        isShowTable: false
      }, {
        set: (recObj, key, value) => {
          // console.log(recObj, key, value)
          recObj[key] = value; // if (key === 'imdbId' || key === 'name' || key === 'year' || key === 'length' || key === 'country'
          //   || key === 'genreList' || key === 'releaseDate' || key === 'videoId' || key === 'rating' || key === 'certification' || key === 'description') {
          //   // console.log(key, 'change')
          //   recObj['ifChange'] = true;
          //   // console.log(formConfig.formData[data.currentSearchIndex]);
          // }

          return true;
        }
      });
    }; // 校验评分输入


    const validatorRating = (rule, value, callback) => {
      if (value == '') {
        callback();
      }

      if (/0[.?0-9]/.test(value)) {
        callback(new Error(t('请输入大于0且不大于10的正整数或一位小数')));
      } else if (value == 0) {
        callback(new Error(t('请输入大于0且不大于10的正整数或一位小数')));
      } else if (value > 10) {
        callback(new Error(t('请输入大于0且不大于10的正整数或一位小数')));
      } else if (String(value).includes('.')) {
        if (/\.$/.test(value)) {
          callback(new Error(t('请输入大于0且不大于10的正整数或一位小数')));
        } else {
          let x = String(value).indexOf(".") + 1; // 得到小数点的位置

          let y = String(value).length - x; // 小数点的位数

          if (y > 1) {
            callback(new Error(t('请输入大于0且不大于10的正整数或一位小数')));
          } else {
            callback();
          }
        }
      } else {
        callback();
      }
    };

    const formConfig = reactive({
      formList: [[{
        label: '信息源ID',
        prop: 'imdbId',
        widgetType: 'input',
        slotName: 'id',
        placeholder: '请输入信息源ID',
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入信息源ID'),
          trigger: ['change', 'blur']
        }]
      }, {
        label: '名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入名称',
        required: true,
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入名称'),
          trigger: ['change', 'blur']
        }, {
          min: 1,
          max: 255,
          message: t('限制字符数量', {
            num: 255
          }),
          trigger: ['change', 'blur']
        }]
      }], [{
        label: '年份',
        prop: 'year',
        widgetType: 'date',
        type: 'year',
        valueFormat: 'YYYY',
        placeholder: '请选择年份',
        required: true,
        rules: [{
          required: true,
          message: t('请选择年份'),
          trigger: 'change'
        }]
      }, {
        label: '影片时长',
        prop: 'length',
        widgetType: 'input',
        required: false,
        rules: [{
          validator: (rule, value, callback) => {
            if (value !== 0 && !value) {
              callback();
            } else if (!/^[1-9]\d*$/.test(value)) {
              callback(new Error(t('请输入大于0的整数')));
            } else if (value.length > 4) {
              callback(new Error(t('限制字符数量', {
                num: 4
              })));
            } else {
              callback();
            }
          },
          trigger: ['change', 'blur']
        }]
      }], [{
        label: '国家',
        prop: 'country',
        widgetType: 'singleSelect',
        placeholder: '请选择国家',
        required: true,
        valueField: 'value',
        nameField: 'label',
        list: [],
        rules: [{
          required: true,
          message: t('请选择国家'),
          trigger: 'change'
        }]
      }, {
        label: '分类属性',
        prop: 'genreList',
        widgetType: 'multipleSelectObj',
        required: true,
        programType: topformConfig.formData.programType,
        list: [],
        rules: [{
          required: true,
          validator: (rules, value, callback) => {
            if (isEmptyArray(value)) {
              callback(new Error(t('请选择分类属性')));
            }

            callback();
          },
          trigger: 'change'
        }]
      }], [{
        label: '上映时间',
        prop: 'releaseDate',
        widgetType: 'date',
        type: 'date',
        valueFormat: 'YYYY-MM-DD',
        itemSlot: true
      }, {
        label: '预告片',
        prop: 'videoId',
        widgetType: 'input',
        required: false,
        rules: [{
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入预告片ID', false)
        }]
      }], [{
        label: '评分',
        prop: 'rating',
        widgetType: 'input',
        required: false,
        min: 1,
        rules: [{
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '', false)
        }, {
          validator: validatorRating
        }],
        input: (e, data) => {
          data.rating = data.rating.replace(/[^.\d]/g, '');
        }
      }, {
        label: '认证',
        prop: 'certification',
        widgetType: 'input',
        required: false,
        rules: [{
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '', false)
        }]
      }], [{
        label: '导演',
        prop: 'directorList',
        widgetType: 'popSelectModel',
        dialogTitle: '选择导演',
        slotName: 'directorList',
        colspan: 3,
        dataList: []
      }], [{
        label: '演员',
        prop: 'actorList',
        widgetType: 'popSelectModel',
        dialogTitle: '选择演员',
        slotName: 'actorList',
        colspan: 3,
        dataList: []
      }], [{
        label: '描述',
        prop: 'description',
        widgetType: 'textarea',
        maxlength: 5000,
        showWordLimit: true,
        autosize: true,
        colspan: 3,
        required: false,
        rules: [{
          max: 5000,
          message: t('限制字符数量', {
            num: '5000'
          }),
          trigger: 'blur'
        }]
      }]],
      formData: finishData.value.detailList && finishData.value.detailList.length > 0 ? finishData.value.detailList : [getProxyObj('en')]
    }); // 获取国家

    const getCountries = async () => {
      const res = await useCountryList();
      let item = getItemByProp(formConfig.formList, 'country');
      item.list = res;
    };

    const data = reactive({
      currentSearchIndex: 0,
      isLock: false
    }); // 获取关联分类

    const getProgramSet = async () => {
      let item = getItemByProp(topformConfig.formList, 'videoSeriesIdList');
      const cid = mediaParams.value ? useCommon().userData.cid[0] || 0 : sessionStorage.getItem('currentCid');
      const res = await getProgramSetApi({
        cid
      });

      if (res.code == '0') {
        item.list = res.data;
      }
    }; // 获取语言全称


    const getLanguageName = val => {
      if (selectOptions.value.length > 0) {
        const item = selectOptions.value.filter(item => {
          return item.value === val;
        });
        return item[0].label;
      }
    };

    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '信息源搜索'
      },
      formData: {
        name: '',
        parent: '',
        sequence: '',
        status: '',
        type: '',
        language: '',
        adult: '',
        description: '',
        paymentForm: undefined
      },
      confirm: () => {
        console.log('386-弹框确定');
        const {
          detailInfo,
          detailMainInfo
        } = searchDialogRef.value.data;
        const {
          formData
        } = searchDialogRef.value.searchConfig;
        let currentData = { ...formConfig.formData[data.currentSearchIndex]
        }; //currentData.ifChange = false;
        //currentData.language = getLanguageName(formData.language);

        currentData.infoId = formData.id;

        if (detailInfo && detailMainInfo) {
          currentData.year = detailMainInfo.year ? String(detailMainInfo.year) : '';
          currentData.name = detailMainInfo.name;
          currentData.imdbId = detailInfo.sourceId;
          currentData.infoId = detailInfo.sourceName;
          currentData.country = detailInfo.country;
          currentData.length = detailInfo.length != 0 ? detailInfo.length : '';
          currentData.directorList = detailInfo.director || [];
          currentData.actorList = detailInfo.actor || [];
          currentData.description = detailInfo.description;
          currentData.genreList = detailInfo.genres;
          currentData.releaseDate = detailInfo.releaseDate || '';
          currentData.videoId = detailInfo.trailerVideoIdList ? detailInfo.trailerVideoIdList.join(',') : ''; //预告片id，有则拼接成字符串显示

          currentData.rating = detailInfo.rating || '';
          currentData.description = detailInfo.description || '';
        }

        formConfig.formData[data.currentSearchIndex] = new Proxy(currentData, {
          set: (recObj, key, value) => {
            // console.log(recObj, key, value)
            recObj[key] = value; // if (key === 'imdbId' || key === 'name' || key === 'year' || key === 'length' || key === 'country'
            //   || key === 'genreList' || key === 'releaseDate' || key === 'videoId' || key === 'rating' || key === 'certification' || key === 'description') {
            //   // console.log(key, 'change')
            //   recObj['ifChange'] = true;
            //   // console.log(formConfig.formData[data.currentSearchIndex]);
            // }

            return true;
          }
        });
        dialogConfig.visible = false;
      }
    });

    const addLanguage = () => {
      let obj = getProxyObj();
      formConfig.formData.push(obj);
    };

    const deleteItem = index => {
      delete formConfig.formList[index];
      formConfig.formData.splice(index, 1);
    };

    const searchVod = index => {
      data.currentSearchIndex = index;
      options.dialogOptions = formConfig.formData[index];
      dialogConfig.visible = true;
    }; // 向外暴露修改form表单显示与否函数


    const changeTableDisplay = arr => {
      arr.forEach(item => {
        formConfig.formData[item].isShowTable = false;
      });
    };

    expose({
      TopFormRef,
      FormRef,
      formConfig,
      topformConfig,
      changeTableDisplay
    });

    const toSeriesFilm = () => {
      emit('toSeriesFilm');
    };

    const getCloudDiskOptions = async () => {
      const {
        code,
        data
      } = await getCloudDiskOptionsApi({
        name: useCommon().userData.name
      });

      if (code == 0) {
        cloudDiskOptions.value = data ? [...data] : [];
      }
    };

    onMounted(() => {
      getCloudDiskOptions();
      getProgramSet();
      getCountries();
    });
    watch(() => finishData.value, val => {
      topformConfig.formData = {
        name: finishData.value.name,
        programType: finishData.value.programType,
        adult: finishData.value.adult,
        videoSeriesIdList: finishData.value.videoSeriesIdList || [],
        sequence: finishData.value.sequence || '',
        cloudDiskIdList: finishData.value.cloudDiskIdList || [],
        paymentForm: finishData.value.paymentForm || 3
      };
      let item = getItemByProp(formConfig.formList, 'genreList');
      item.programType = finishData.value.programType;

      if (finishData.value.detailList && finishData.value.detailList.length > 0) {
        formConfig.formData = finishData.value.detailList.map(item => {
          let newItem = { ...item,
            year: String(item.year),
            // 信息源Id的下拉选项，根据input输入的字符串决定的
            infoId: String(item.imdbId).includes('tt') ? 'imdb' : String(item.imdbId).includes('ar') ? 'arab' : 'tmdb'
          };
          return new Proxy(newItem, {
            set: (recObj, key, value) => {
              // console.log(recObj, key, value)
              recObj[key] = value; // if (key === 'imdbId' || key === 'name' || key === 'year' || key === 'length' || key === 'country'
              //   || key === 'genreList' || key === 'releaseDate' || key === 'videoId' || key === 'rating' || key === 'certification' || key === 'description') {
              //   // console.log(key, 'change')
              //   recObj['ifChange'] = true;
              //   // console.log(formConfig.formData);
              // }

              return true;
            }
          });
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => [...formConfig.formData], val => {
      addDisabledForOptions(val);
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_WidgetItem = _resolveComponent("WidgetItem");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        model: topformConfig.formData,
        ref_key: "TopFormRef",
        ref: TopFormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['15%', '35%', '15%', '35%'], (c, i) => {
          return _createElementVNode("col", {
            width: c,
            key: i
          }, null, 8, _hoisted_4);
        }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topformConfig.formData.programType == 'tv_series' ? topformConfig.formList : topformConfig.formList.slice(0, 3), (item, index) => {
          return _openBlock(), _createBlock(FormItem, {
            key: index,
            "form-item": item,
            "form-data": topformConfig.formData,
            c_index: -1
          }, {
            itemSlot: _withCtx(scope => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_WidgetItem, {
              widgetConfig: scope,
              "widget-data": topformConfig.formData
            }, null, 8, ["widgetConfig", "widget-data"]), _createVNode(_component_el_button, {
              onClick: toSeriesFilm,
              class: "cms-op-btn cms-op-btn-light mg-l--15"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('新建系列')), 1)]),
              _: 1
            })])]),
            _: 2
          }, 1032, ["form-item", "form-data"]);
        }), 128))])])])]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_form, {
        model: formConfig.formData,
        ref_key: "FormRef",
        ref: FormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createVNode(FormGroup, {
            col: ['15%', '35%', '15%', '35%'],
            "form-list": formConfig.formList,
            "form-data": formConfig.formData[index],
            c_index: Number(index),
            languageOptions: _unref(selectOptions),
            onAddLanguage: addLanguage,
            onDeleteItem: deleteItem,
            onSearchVod: searchVod
          }, null, 8, ["form-list", "form-data", "c_index", "languageOptions"])]);
        }), 128))]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '70%',
          top: '6vh',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(SearchDialog, {
          modelValue: dialogConfig.visible,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogConfig.visible = $event),
          ref_key: "searchDialogRef",
          ref: searchDialogRef,
          options: options,
          "onUpdate:options": _cache[1] || (_cache[1] = $event => _isRef(options) ? options.value = $event : null),
          programType: topformConfig.formData.programType,
          dialogOptions: options.dialogOptions
        }, null, 8, ["modelValue", "options", "programType", "dialogOptions"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])]);
    };
  }

});